import React from 'react';

import { KebabMenu, type MenuItemState } from '~/components/KebabMenu';

export interface Action {
  id: string;
  label: string | React.ReactNode;
  callback?: (e: React.MouseEvent) => void;
  state?: MenuItemState;
}

interface Props {
  actions: Action[];
}

export function ActionsMenu({ actions }: Props) {
  if (!actions.length) {
    return null;
  }

  return (
    <KebabMenu>
      {actions.map(({ id, label, callback, state }) => (
        <KebabMenu.Item
          onClick={(e) => {
            e.stopPropagation();

            if (callback) {
              callback(e);
            }
          }}
          key={id}
          state={state}
        >
          {label}
        </KebabMenu.Item>
      ))}
    </KebabMenu>
  );
}

ActionsMenu.displayName = 'ActionsListMenu';
